import React, { useEffect, useState, useRef } from 'react';
import { 
  Send, Search, FileSpreadsheet, X, MessageSquare, ShieldAlert, 
  LogIn, Users, Trash, BookOpen, Download, ChevronDown, 
  Image as ImageIcon, Plus, Link as LinkIcon, Paperclip, Video, FileText, Type as TypeIcon,
  Smile
} from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import api from '../utils/api';
import axios from 'axios';
import FullScreenLoader from '../components/Loader';
import Container from '../components/Container';

const WABA_ID = '2228640350973996';
const PhoneNo ="684519224755674";
const WHATSAPP_TOKEN = 'EAAR7RxDZAOvMBP9UKBD5yxYgptfMXqphiPZCFrh2Huxb5AREvD35hudgZC4htDa4gsPbLZBQyCcpdqTwI4dAX2Izl3oPXpoZBBO4Vh4K833ZCWJlEv9kgUGEHyHddP1AzrZCgVByTGsGoiYZBCvH7YaSLzGwspw4BXLI8GhgDsiN7YnSGrPa9JdeqxVZANkL55wZDZD';

const EMOJI_CATEGORIES = [
  {
    id: 'smileys',
    name: 'Smileys',
    icon: '😀',
    emojis: [
      { char: '😀', keywords: 'grinning face smile happy' },
      { char: '😃', keywords: 'smiley face happy joy' },
      { char: '😄', keywords: 'smile happy joy laugh' },
      { char: '😁', keywords: 'grin happy beam' },
      { char: '😆', keywords: 'laugh closed eyes funny haha' },
      { char: '😅', keywords: 'sweat smile relief nervous' },
      { char: '🤣', keywords: 'rofl rolling laughing funny haha' },
      { char: '😂', keywords: 'joy tears laugh haha funny' },
      { char: '🙂', keywords: 'slight smile happy' },
      { char: '🙃', keywords: 'upside down silly sarcastic' },
      { char: '😉', keywords: 'wink flirt playful' },
      { char: '😊', keywords: 'blush smile pleased warmth' },
      { char: '😇', keywords: 'halo innocent angel' },
      { char: '🥰', keywords: 'love hearts smiling adored' },
      { char: '😍', keywords: 'heart eyes love gorgeous' },
      { char: '🤩', keywords: 'star struck excited' },
      { char: '😘', keywords: 'kiss love heart blow kiss' },
      { char: '😋', keywords: 'yum delicious tongue tasty food' },
      { char: '😛', keywords: 'tongue silly playful' },
      { char: '😜', keywords: 'wink tongue wacky crazy' },
      { char: '🤪', keywords: 'zany goofy crazy funny' },
      { char: '🤑', keywords: 'money face rich cash dollar' },
      { char: '🤗', keywords: 'hugs warm welcome' },
      { char: '🤭', keywords: 'giggle hand over mouth oops' },
      { char: '🤫', keywords: 'shh quiet secret silent' },
      { char: '🤔', keywords: 'thinking ponder hmm wonder' },
      { char: '🤐', keywords: 'zipper mouth secret quiet' },
      { char: '🤨', keywords: 'raised eyebrow suspicious skeptical' },
      { char: '😏', keywords: 'smirk cool clever sly' },
      { char: '😌', keywords: 'relieved calm peace' },
      { char: '😴', keywords: 'sleeping zzz tired' },
      { char: '🥳', keywords: 'party celebration celebrate hat horn' },
      { char: '😎', keywords: 'sunglasses cool stylish boss' },
      { char: '🤓', keywords: 'nerd glasses smart geek' }
    ]
  },
  {
    id: 'gestures',
    name: 'Gestures',
    icon: '👍',
    emojis: [
      { char: '👍', keywords: 'thumbs up like good yes approve ok' },
      { char: '👎', keywords: 'thumbs down dislike bad no' },
      { char: '👌', keywords: 'ok hand perfect nice' },
      { char: '✌️', keywords: 'peace victory v hand' },
      { char: '🤞', keywords: 'fingers crossed luck wish hope' },
      { char: '🫰', keywords: 'finger heart love money snap' },
      { char: '🤟', keywords: 'love you gesture rock' },
      { char: '🤘', keywords: 'rock on metal horns' },
      { char: '🤙', keywords: 'call me shaka phone' },
      { char: '👈', keywords: 'point left finger' },
      { char: '👉', keywords: 'point right finger' },
      { char: '👆', keywords: 'point up finger' },
      { char: '👇', keywords: 'point down finger' },
      { char: '☝️', keywords: 'index point up one attention' },
      { char: '✋', keywords: 'hand stop five high five' },
      { char: '👋', keywords: 'wave hello goodbye hi bye' },
      { char: '🤝', keywords: 'handshake deal agree partnership meet' },
      { char: '👏', keywords: 'clap applause bravo congratulations well done' },
      { char: '🙌', keywords: 'raising hands celebrate praise cheer hooray' },
      { char: '🙏', keywords: 'pray please thank you namaste thanks worship' },
      { char: '✍️', keywords: 'writing hand note pen author' },
      { char: '💪', keywords: 'flexed biceps strong muscle power fitness' }
    ]
  },
  {
    id: 'celebration',
    name: 'Celebration',
    icon: '🎉',
    emojis: [
      { char: '❤️', keywords: 'red heart love passion' },
      { char: '🧡', keywords: 'orange heart love' },
      { char: '💛', keywords: 'yellow heart friendship' },
      { char: '💚', keywords: 'green heart nature eco' },
      { char: '💙', keywords: 'blue heart trust peace' },
      { char: '💜', keywords: 'purple heart luxury' },
      { char: '🤍', keywords: 'white heart pure peace' },
      { char: '💕', keywords: 'two hearts love floating' },
      { char: '💖', keywords: 'sparkling heart shiny love' },
      { char: '🎉', keywords: 'party popper tada celebrate celebration event' },
      { char: '🎊', keywords: 'confetti ball celebration party' },
      { char: '🎈', keywords: 'balloon party birthday celebrate' },
      { char: '🎁', keywords: 'gift present surprise box birthday offer' },
      { char: '🎂', keywords: 'birthday cake dessert celebration sweet' },
      { char: '✨', keywords: 'sparkles shine magic special new star' },
      { char: '🌟', keywords: 'glowing star bright shining rate review' },
      { char: '⭐', keywords: 'star favorite rating review gold' },
      { char: '🔥', keywords: 'fire hot trending popular flame deal sale' },
      { char: '💥', keywords: 'boom explosion blast offer big' },
      { char: '🏆', keywords: 'trophy winner champion award prize first' },
      { char: '🥇', keywords: 'first place gold medal winner' }
    ]
  },
  {
    id: 'travel',
    name: 'Travel & Cabs',
    icon: '🚗',
    emojis: [
      { char: '🚗', keywords: 'car automobile cab taxi vehicle drive bookfast' },
      { char: '🚕', keywords: 'taxi cab yellow ride pickup' },
      { char: '🚙', keywords: 'suv car vehicle trip drive' },
      { char: '🚌', keywords: 'bus transit travel transport' },
      { char: '🏎️', keywords: 'race car fast speed sport' },
      { char: '🚐', keywords: 'minibus van travel tour' },
      { char: '🚚', keywords: 'delivery truck cargo logistics' },
      { char: '🛵', keywords: 'motor scooter bike delivery ride' },
      { char: '🏍️', keywords: 'motorcycle bike ride speed' },
      { char: '✈️', keywords: 'airplane flight travel tour holiday airport' },
      { char: '🛫', keywords: 'airplane departure takeoff fly trip' },
      { char: '🛬', keywords: 'airplane arrival landing arrival' },
      { char: '🚆', keywords: 'bullet train railway transit' },
      { char: '📍', keywords: 'location pin map gps destination pickup drop' },
      { char: '🗺️', keywords: 'world map direction travel navigation' },
      { char: '⛽', keywords: 'fuel pump gas petrol diesel station' }
    ]
  },
  {
    id: 'business',
    name: 'Business',
    icon: '💼',
    emojis: [
      { char: '💼', keywords: 'briefcase work business corporate job' },
      { char: '📞', keywords: 'telephone phone call contact hotline support' },
      { char: '📱', keywords: 'mobile phone smartphone call whatsapp app' },
      { char: '📲', keywords: 'mobile phone with arrow call incoming message' },
      { char: '💻', keywords: 'laptop computer tech website online' },
      { char: '📧', keywords: 'email e-mail mail inbox letter message' },
      { char: '📣', keywords: 'megaphone cheer announcement broadcast shout' },
      { char: '📢', keywords: 'loudspeaker announcement broadcast news alert' },
      { char: '🔔', keywords: 'bell alert notification ring reminder' },
      { char: '⏰', keywords: 'alarm clock time schedule reminder deadline' },
      { char: '📅', keywords: 'calendar date schedule event booking booking_date' },
      { char: '📝', keywords: 'memo note paper pencil write form terms' },
      { char: '📌', keywords: 'pushpin pin important notice point note' },
      { char: '💰', keywords: 'money bag cash wealth cost price fare payment' },
      { char: '💵', keywords: 'dollar banknote money currency cash bill' },
      { char: '💳', keywords: 'credit card payment debit swipe online checkout' },
      { char: '🧾', keywords: 'receipt bill invoice payment proof slip' }
    ]
  },
  {
    id: 'symbols',
    name: 'Symbols',
    icon: '✅',
    emojis: [
      { char: '✅', keywords: 'check mark green verified confirmed done approved ok' },
      { char: '✔️', keywords: 'check mark done complete right correct' },
      { char: '☑️', keywords: 'check box tick selected active' },
      { char: '❌', keywords: 'cross mark x cancelled wrong rejected error' },
      { char: '⚠️', keywords: 'warning alert caution attention important note' },
      { char: '💯', keywords: 'hundred 100 perfect score full best deal' },
      { char: '🆗', keywords: 'ok button agree confirm cool' },
      { char: '🆒', keywords: 'cool button nice awesome' },
      { char: '🆕', keywords: 'new button badge latest fresh launch' },
      { char: '🆓', keywords: 'free button offer bonus complimentary zero' },
      { char: 'ℹ️', keywords: 'info information guide details notice' },
      { char: '❓', keywords: 'question mark help faq inquiry' },
      { char: '❗️', keywords: 'exclamation mark urgent important alert' },
      { char: '🔴', keywords: 'red circle live alert status' },
      { char: '🟢', keywords: 'green circle active online available open' },
      { char: '🔵', keywords: 'blue circle info standard link' }
    ]
  }
];

const BroadCastManager = () => {
  const [contacts, setContacts] = useState([]);
  const [excelContacts, setExcelContacts] = useState([]);
  const [showChatContacts, setShowChatContacts] = useState(true);
  const [loading, setLoading] = useState(false);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [message, setMessage] = useState('');
  const [templateList, setTemplateList] = useState([]);
  const [selectedTemplateId, setSelectedTemplateId] = useState('');

  const [templateSource, setTemplateSource] = useState('message');
  const [whatsappTemplateList, setWhatsappTemplateList] = useState([]);
  const [selectedWaTemplate, setSelectedWaTemplate] = useState(null);
  const [templateVariables, setTemplateVariables] = useState({});

  const [messageType, setMessageType] = useState('simple'); 
  const [links, setLinks] = useState([{ title: '', url: '' }]);

  // Media States
  const [selectedImages, setSelectedImages] = useState([]); 
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [previewIndex, setPreviewIndex] = useState(null);
  
  // Attachment & Emoji Popup State
  const [showAttachmentMenu, setShowAttachmentMenu] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [emojiSearch, setEmojiSearch] = useState('');
  const [activeEmojiCat, setActiveEmojiCat] = useState('all');
  const [activeVariableKey, setActiveVariableKey] = useState(null);
  
  // Refs
  const attachmentRef = useRef(null);
  const clipBtnRef = useRef(null);
  const emojiPickerRef = useRef(null);
  const emojiBtnRef = useRef(null);
  const messageInputRef = useRef(null);

  const islogedIn = localStorage.getItem('loggedIn');

  // --- LOGIC FIX: History Toggle ---
  // Agar showChatContacts false hai toh sirf excelContacts filter honge
  const rawList = showChatContacts ? [...contacts, ...excelContacts] : excelContacts;
  const uniqueContacts = Array.from(new Map(rawList.map(c => [String(c.phone), c])).values());
  const filteredContacts = uniqueContacts.filter(c => String(c?.phone || "").includes(searchTerm));

  // Jab history toggle ho, selected contacts ko clean karein jo ab list mein nahi hain
  useEffect(() => {
    const validPhones = uniqueContacts.map(c => c.phone);
    setSelectedContacts(prev => prev.filter(phone => validPhones.includes(phone)));
  }, [showChatContacts]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showAttachmentMenu) {
        if (
          attachmentRef.current && !attachmentRef.current.contains(event.target) &&
          clipBtnRef.current && !clipBtnRef.current.contains(event.target)
        ) {
          setShowAttachmentMenu(false);
        }
      }
      if (showEmojiPicker) {
        if (
          emojiPickerRef.current && !emojiPickerRef.current.contains(event.target) &&
          emojiBtnRef.current && !emojiBtnRef.current.contains(event.target)
        ) {
          setShowEmojiPicker(false);
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showAttachmentMenu, showEmojiPicker]);

  const filteredEmojis = React.useMemo(() => {
    if (emojiSearch.trim()) {
      const q = emojiSearch.toLowerCase().trim();
      const all = EMOJI_CATEGORIES.flatMap(cat => cat.emojis);
      return all.filter(e => e.keywords.toLowerCase().includes(q) || e.char.includes(q));
    }
    if (activeEmojiCat === 'all') {
      return EMOJI_CATEGORIES.flatMap(cat => cat.emojis);
    }
    const found = EMOJI_CATEGORIES.find(cat => cat.id === activeEmojiCat);
    return found ? found.emojis : [];
  }, [emojiSearch, activeEmojiCat]);

  const handleEmojiSelect = (emoji) => {
    if (templateSource === 'whatsapp') {
      const keys = Object.keys(templateVariables);
      if (keys.length > 0) {
        const targetKey = (activeVariableKey && keys.includes(activeVariableKey)) ? activeVariableKey : keys[0];
        setTemplateVariables(prev => ({
          ...prev,
          [targetKey]: (prev[targetKey] || '') + emoji
        }));
      }
    } else {
      const textarea = messageInputRef.current;
      if (textarea) {
        const start = textarea.selectionStart ?? message.length;
        const end = textarea.selectionEnd ?? message.length;
        const newMsg = message.substring(0, start) + emoji + message.substring(end);
        setMessage(newMsg);
        setTimeout(() => {
          textarea.focus();
          const newPos = start + emoji.length;
          textarea.setSelectionRange(newPos, newPos);
        }, 0);
      } else {
        setMessage(prev => prev + emoji);
      }
    }
  };

  useEffect(() => {
    fetchChatList();
    getTemplate();
    getWhatsappTemplates();
  }, []);

  const getWhatsappTemplates = async () => {
    try {
      const response = await axios.get(`/fb-api/v19.0/${WABA_ID}/message_templates`, {
        headers: {
          'Authorization': `Bearer ${WHATSAPP_TOKEN}`
        }
      });
      if (response.status === 200 && response.data && response.data.data) {
        setWhatsappTemplateList(response.data.data);
      }
    } catch (err) { console.error("Error fetching whatsapp templates:", err); }
  };

  const getTemplate = async () => {
    try {
      const response = await api.get('/template/get-template');
      if (response.status === 200) setTemplateList(response.data);
    } catch (err) { console.error("Error fetching templates:", err); }
  };

  const fetchChatList = async () => {
    setLoading(true);
    try {
      const res = await api.get('/contacts');
      if (res?.status === 200) {
        let data = res?.data?.map((v) => ({ id: v?.id, phone: String(v?.wa_id), source: 'chats' }));
        setContacts(data);
      }
    } catch (err) { console.error(err); } finally { setLoading(false); }
  };

  const handleTemplateChange = async (e) => {
    const tplId = e.target.value;
    setSelectedTemplateId(tplId);
    if (!tplId) { setMessage(''); setSelectedImages([]); return; }

    const selectedTpl = templateList.find(t => String(t.id) === String(tplId));
    if (selectedTpl) {
      setMessage(selectedTpl.content || "");
      if (selectedTpl.image_url) {
        setLoading(true);
        try {
          const response = await fetch(selectedTpl.image_url);
          const blob = await response.blob();
          const file = new File([blob], "template-image.jpg", { type: blob.type });
          setSelectedImages([{ file, preview: URL.createObjectURL(file) }]);
          setSelectedVideo(null); setSelectedDoc(null);
        } catch (err) { toast.error("Template image load fail"); } finally { setLoading(false); }
      } else { setSelectedImages([]); }
    }
  };

  const handleWaTemplateChange = (e) => {
    const tplName = e.target.value;
    if (!tplName) {
        setSelectedWaTemplate(null);
        setMessage('');
        setTemplateVariables({});
        return;
    }
    const tpl = whatsappTemplateList.find(t => t.name === tplName);
    setSelectedWaTemplate(tpl);
    if (tpl) {
        const bodyComp = tpl.components.find(c => c.type === 'BODY');
        const text = bodyComp ? bodyComp.text : '';
        setMessage(text);
        
        const matches = text.match(/{{[0-9]+}}/g) || [];
        const uniqueVars = Array.from(new Set(matches));
        const initialVars = {};
        uniqueVars.forEach(v => {
            initialVars[v] = '';
        });
        setTemplateVariables(initialVars);
        
        setSelectedImages([]); setSelectedVideo(null); setSelectedDoc(null);
    }
  };

  const getPreviewMessage = () => {
    let preview = message;
    if (templateSource === 'whatsapp') {
      Object.keys(templateVariables).forEach(key => {
        const val = templateVariables[key];
        if (val) {
           preview = preview.split(key).join(val);
        }
      });
    }
    return preview;
  };

  // --- SAMPLE EXCEL DOWNLOAD ---
  const downloadSampleExcel = () => {
    const data = [{ phone: '911234567890' }, { phone: '919876543210' }];
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sample");
    XLSX.writeFile(workbook, "broadcast_sample.xlsx");
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    
    // Check file size (2MB limit)
    const validFiles = [];
    for (let file of files) {
      if (file.size > 2097152) {
        toast.error(`${file.name} exceeds the 2MB limit.`);
      } else {
        validFiles.push(file);
      }
    }
    
    if (validFiles.length === 0) {
      e.target.value = null;
      return;
    }

    const newImages = validFiles.map(file => ({ file, preview: URL.createObjectURL(file) }));
    setSelectedImages(prev => [...prev, ...newImages]);
    setSelectedVideo(null); setSelectedDoc(null);
    setShowAttachmentMenu(false);
  };

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    if (file.size > 2097152) {
      toast.error("Video file exceeds the 2MB limit.");
      e.target.value = null;
      return;
    }
    
    setSelectedVideo({ file, preview: URL.createObjectURL(file) });
    setSelectedImages([]); setSelectedDoc(null);
    setShowAttachmentMenu(false);
  };

  const handleDocChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 2097152) {
      toast.error("Document file exceeds the 2MB limit.");
      e.target.value = null;
      return;
    }
    setSelectedDoc({ file, name: file.name });
    setSelectedImages([]); setSelectedVideo(null);
    setShowAttachmentMenu(false);
  };

  const handleLinkChange = (index, field, value) => {
    const newLinks = [...links];
    newLinks[index][field] = value;
    setLinks(newLinks);
  };

  const addNewLink = () => setLinks([...links, { title: '', url: '' }]);

  const handleSelectAll = (checked) => {
    if (checked) setSelectedContacts(filteredContacts.map(c => c.phone));
    else setSelectedContacts([]);
  };

  const toggleSelect = (phone) => {
    setSelectedContacts(prev => prev.includes(phone) ? prev.filter(p => p !== phone) : [...prev, phone]);
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: 'binary' });
      const ws = wb.Sheets[wb.SheetNames[0]];
      const data = XLSX.utils.sheet_to_json(ws);
      const formattedData = data.map((item, index) => {
        const lowerItem = Object.keys(item).reduce((acc, key) => { acc[key.toLowerCase()] = item[key]; return acc; }, {});
        let rawPhone = String(lowerItem.contact || lowerItem.phone || '').trim().replace(/\s+/g, '');
        if (rawPhone && !rawPhone.startsWith('91')) rawPhone = '91' + rawPhone;
        return { id: `excel-${Date.now()}-${index}`, phone: rawPhone, source: 'Excel' };
      }).filter(item => item.phone !== '91' && item.phone.length > 2); 
      setExcelContacts(formattedData);
      toast.success(`${formattedData.length} contacts imported!`);
    };
    reader.readAsBinaryString(file);
  };

  const sendBroadcastMessage = async () => {
    try {
      
      setLoading(true);
      // Final Filter: Sirf wo contacts jo selected hain aur current unique list mein hain
      const finalContacts = uniqueContacts.filter(c => selectedContacts.includes(c.phone));
      
      if (templateSource === 'whatsapp' && selectedWaTemplate) {
          const sortedKeys = Object.keys(templateVariables).sort((a,b) => {
             const numA = parseInt(a.replace(/\D/g, ''));
             const numB = parseInt(b.replace(/\D/g, ''));
             return numA - numB;
          });
          const orderedVariables = sortedKeys.map(k => templateVariables[k]);
          
          const parameters = orderedVariables.map(val => ({
              type: "text",
              text: val
          }));

          const headerComponent = selectedWaTemplate.components.find(c => c.type === 'HEADER');
          let mediaFile = null;
          
          if (headerComponent && ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(headerComponent.format)) {
              if (headerComponent.format === 'IMAGE' && selectedImages.length > 0) mediaFile = selectedImages[0].file;
              else if (headerComponent.format === 'VIDEO' && selectedVideo) mediaFile = selectedVideo.file;
              else if (headerComponent.format === 'DOCUMENT' && selectedDoc) mediaFile = selectedDoc.file;

              if (!mediaFile) {
                  toast.error(`Please attach a ${headerComponent.format.toLowerCase()} for the template header using the attachment menu.`);
                  setLoading(false);
                  return;
              }
          }
          
          const formData = new FormData();
          formData.append('contacts', JSON.stringify(finalContacts));
          formData.append('templateName', selectedWaTemplate.name);
          formData.append('languageCode', selectedWaTemplate.language || "en_US");
          formData.append('parameters', JSON.stringify(parameters));
          formData.append('message', getPreviewMessage());
          
          if (headerComponent) {
              formData.append('headerFormat', headerComponent.format.toLowerCase());
          }
          
          if (mediaFile) {
              formData.append('file', mediaFile);
          }
          
          try {
              // Call the new backend API endpoint that you will create
              await api.post('/whatsapp/send-template-broadcast', formData);
              toast.success(`Template broadcast started successfully!`);
          } catch (e) {
              console.error('Failed to send template broadcast', e);
              if(e?.response?.data?.error){
                 toast.error(e?.response?.data?.error);
              } else {
                 toast.error("Failed to send template broadcast.");
              }
          }
          
          setMessage(''); setSelectedImages([]); setSelectedVideo(null); setSelectedDoc(null);
          setSelectedContacts([]); setLinks([{ title: '', url: '' }]);
          
      } else {
          const formData = new FormData();
          formData.append('contacts', JSON.stringify(finalContacts));
          formData.append('message', message);
          formData.append('messageType', messageType);

          if (messageType === 'link') {
            const validLinks = links.filter(l => l.title.trim() !== '' && l.url.trim() !== '');
            formData.append('buttons', JSON.stringify(validLinks));
          }

          selectedImages.forEach((imgObj) => { if(imgObj.file) formData.append('images', imgObj.file); });
          if (selectedVideo) formData.append('video', selectedVideo.file);
          if (selectedDoc) formData.append('document', selectedDoc.file);

          await api.post('/whatsapp/broadcast', formData);

          toast.success("Broadcast Started!");
          setMessage(''); setSelectedImages([]); setSelectedVideo(null); setSelectedDoc(null);
          setSelectedContacts([]); setLinks([{ title: '', url: '' }]);
      }
    } catch (err) { 
      if(err?.response?.data?.error){
        toast.error(err?.response?.data?.error);
      } else {
        toast.error("Failed to send.");
      }
    } finally { setLoading(false); }
  };

  return (
    <Container title={'Broadcast'} onClick={fetchChatList} rightSection={
      <div style={styles.statusBadge}>
        <div style={styles.dot}></div> {selectedContacts.length} Selected
      </div>}>
      {loading && <FullScreenLoader />}

      <div style={styles.topActionRow}>
        <div style={styles.templateCard}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <BookOpen size={18} color="#4f46e5" />
                <span style={{ fontSize: '13px', fontWeight: '700' }}>Template</span>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <label style={{ fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }}>
                  <input type="radio" name="tplSource" checked={templateSource === 'message'} onChange={() => { setTemplateSource('message'); setMessage(''); setSelectedWaTemplate(null); setTemplateVariables({}); }} />
                  Message Template
                </label>
                <label style={{ fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }}>
                  <input type="radio" name="tplSource" checked={templateSource === 'whatsapp'} onChange={() => { setTemplateSource('whatsapp'); setMessage(''); setSelectedTemplateId(''); setTemplateVariables({}); }} />
                  WhatsApp Template
                </label>
              </div>
            </div>
            {templateSource === 'message' ? (
              <select style={{...styles.dropdown, width: '100%'}} value={selectedTemplateId} onChange={handleTemplateChange}>
                <option value="">-- Select Message Template --</option>
                {templateList.map((tpl) => <option key={tpl.id} value={tpl.id}>{tpl.title}</option>)}
              </select>
            ) : (
              <select style={{...styles.dropdown, width: '100%'}} value={selectedWaTemplate?.name || ''} onChange={handleWaTemplateChange}>
                <option value="">-- Select WhatsApp Template --</option>
                {whatsappTemplateList.map((tpl) => <option key={tpl.id} value={tpl.name}>{tpl.name}</option>)}
              </select>
            )}
          </div>
        </div>

        <div style={styles.toggleCardInline}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Users size={18} color={showChatContacts ? "#4f46e5" : "#94a3b8"} />
            <span style={{ fontSize: '13px', fontWeight: '700' }}>History</span>
          </div>
          <div onClick={() => setShowChatContacts(!showChatContacts)} style={{...styles.switchBase, backgroundColor: showChatContacts ? '#4f46e5' : '#cbd5e1'}}>
            <div style={{...styles.switchKnob, left: showChatContacts ? '22px' : '2px'}} />
          </div>
        </div>
      </div>

      <div style={styles.grid}>
        <div style={styles.leftPanel}>
          <div style={styles.card}>
            {/* Header Content Section */}
            <div style={{...styles.toggleCardInline, border:0, paddingLeft:0, paddingRight:0, marginBottom: 15}}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <MessageSquare size={18} color="#4f46e5" />
                <span style={{ fontSize: '13px', fontWeight: '700' }}>Message</span>
              </div>
              {templateSource === 'message' && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ fontSize: '12px', fontWeight: '700', color: '#64748b' }}>Interactive Buttons</span>
                    <div onClick={() => setMessageType(messageType==='link'?'simple':'link')} style={{...styles.switchBase, width: 38, height: 20, backgroundColor: messageType === 'link' ? '#4f46e5' : '#cbd5e1'}}>
                      <div style={{...styles.switchKnob, width: 16, height: 16, left: messageType === 'link' ? '20px' : '2px'}} />
                    </div>
                  </div>
              )}
            </div>

            <div style={{ position: 'relative' }}>
                {templateSource === 'whatsapp' ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        {Object.keys(templateVariables).length > 0 && (
                           <div style={styles.variablesContainer}>
                              <div style={styles.variablesHeader}><TypeIcon size={14} /> Template Variables</div>
                              <div style={styles.variablesGrid}>
                                  {Object.keys(templateVariables).map(key => (
                                     <div key={key} style={styles.variableRow}>
                                        <span style={styles.variableLabel}>{key}</span>
                                        <input 
                                           style={styles.variableInput} 
                                           placeholder={`Value for ${key}`} 
                                           value={templateVariables[key]} 
                                           onFocus={() => setActiveVariableKey(key)}
                                           onChange={(e) => setTemplateVariables({...templateVariables, [key]: e.target.value})} 
                                        />
                                     </div>
                                  ))}
                              </div>
                           </div>
                        )}
                        {selectedWaTemplate && selectedWaTemplate.components.find(c => c.type === 'HEADER' && ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(c.format)) && (
                            <div style={{ padding: '10px', backgroundColor: '#fffbeb', color: '#b45309', borderRadius: '8px', fontSize: '13px', border: '1px solid #fde68a' }}>
                                <strong>Note:</strong> This template requires a <b>{selectedWaTemplate.components.find(c => c.type === 'HEADER').format.toLowerCase()}</b> header. Please attach one below before sending.
                            </div>
                        )}
                        <div style={styles.whatsappBubbleContainer}>
                            <div style={styles.whatsappBubble}>
                                <div style={styles.whatsappText}>{getPreviewMessage() || "Select a WhatsApp Template..."}</div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <textarea 
                      ref={messageInputRef}
                      style={styles.textArea} 
                      placeholder="Type your message..." 
                      value={message} 
                      onChange={(e) => setMessage(e.target.value)} 
                    />
                )}

                <div style={styles.attachmentButtonContainer}>
                    <button 
                        ref={clipBtnRef} 
                        type="button"
                        onClick={() => {
                            setShowAttachmentMenu(!showAttachmentMenu);
                            setShowEmojiPicker(false);
                        }} 
                        style={styles.clipBtn}
                        title="Attach Media"
                    >
                        <Paperclip size={20} style={{ transform: 'rotate(45deg)', color: showAttachmentMenu ? '#4f46e5' : '#64748b' }} />
                    </button>

                    <button 
                        ref={emojiBtnRef} 
                        type="button"
                        onClick={() => {
                            setShowEmojiPicker(!showEmojiPicker);
                            setShowAttachmentMenu(false);
                        }} 
                        style={styles.emojiBtn}
                        title="Insert Emoji"
                    >
                        <Smile size={20} color={showEmojiPicker ? '#4f46e5' : '#64748b'} />
                    </button>
                </div>

                {showAttachmentMenu && (() => {
                    const headerFormat = templateSource === 'whatsapp' && selectedWaTemplate 
                        ? selectedWaTemplate.components.find(c => c.type === 'HEADER')?.format 
                        : null;
                    return (
                        <div ref={attachmentRef} style={styles.attachmentPopup}>
                            {(!headerFormat || headerFormat === 'IMAGE') && (
                                <label style={styles.popupItem}>
                                    <div style={{ ...styles.popupIconCircle, backgroundColor: '#bf5af2' }}><ImageIcon size={20} color="white" /></div>
                                    <span>Images</span>
                                    <input type="file" accept="image/*" multiple hidden onChange={handleImageChange} />
                                </label>
                            )}
                            {(!headerFormat || headerFormat === 'VIDEO') && (
                                <label style={styles.popupItem}>
                                    <div style={{ ...styles.popupIconCircle, backgroundColor: '#ff453a' }}><Video size={20} color="white" /></div>
                                    <span>Video</span>
                                    <input type="file" accept="video/*" hidden onChange={handleVideoChange} />
                                </label>
                            )}
                            {(!headerFormat || headerFormat === 'DOCUMENT') && (
                                <label style={styles.popupItem}>
                                    <div style={{ ...styles.popupIconCircle, backgroundColor: '#007aff' }}><FileText size={20} color="white" /></div>
                                    <span>PDF</span>
                                    <input type="file" accept=".pdf" hidden onChange={handleDocChange} />
                                </label>
                            )}
                        </div>
                    );
                })()}

                {showEmojiPicker && (
                    <div ref={emojiPickerRef} style={styles.emojiPickerPopup}>
                        {/* Search & Header */}
                        <div style={styles.emojiPickerHeader}>
                            <div style={styles.emojiSearchWrapper}>
                                <Search size={14} color="#94a3b8" />
                                <input 
                                    type="text" 
                                    placeholder="Search emojis..." 
                                    value={emojiSearch} 
                                    onChange={(e) => setEmojiSearch(e.target.value)} 
                                    style={styles.emojiSearchInput}
                                />
                                {emojiSearch && (
                                    <button 
                                        type="button" 
                                        onClick={() => setEmojiSearch('')} 
                                        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, color: '#94a3b8', display: 'flex' }}
                                    >
                                        <X size={13} />
                                    </button>
                                )}
                            </div>
                            <button 
                                type="button" 
                                onClick={() => setShowEmojiPicker(false)} 
                                style={styles.emojiCloseBtn}
                            >
                                <X size={16} />
                            </button>
                        </div>

                        {/* Category Tabs */}
                        {!emojiSearch.trim() && (
                            <div style={styles.emojiCategoriesRow}>
                                <button 
                                    type="button"
                                    onClick={() => setActiveEmojiCat('all')} 
                                    style={activeEmojiCat === 'all' ? styles.emojiCatBtnActive : styles.emojiCatBtn}
                                >
                                    All
                                </button>
                                {EMOJI_CATEGORIES.map(cat => (
                                    <button 
                                        key={cat.id} 
                                        type="button"
                                        onClick={() => setActiveEmojiCat(cat.id)} 
                                        style={activeEmojiCat === cat.id ? styles.emojiCatBtnActive : styles.emojiCatBtn}
                                        title={cat.name}
                                    >
                                        {cat.icon}
                                    </button>
                                ))}
                            </div>
                        )}

                        {/* Emoji Grid */}
                        <div style={styles.emojiGrid}>
                            {filteredEmojis.length === 0 ? (
                                <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '20px 10px', color: '#94a3b8', fontSize: '12px' }}>
                                    No emojis found
                                </div>
                            ) : (
                                filteredEmojis.map((item, idx) => (
                                    <button 
                                        key={idx} 
                                        type="button"
                                        onClick={() => handleEmojiSelect(item.char)} 
                                        style={styles.emojiCell}
                                        title={item.keywords || item.char}
                                        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f1f5f9'; e.currentTarget.style.transform = 'scale(1.2)'; }}
                                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.transform = 'scale(1)'; }}
                                    >
                                        {item.char}
                                    </button>
                                ))
                            )}
                        </div>
                    </div>
                )}
            </div>

            {/* Media Previews */}
            {(selectedImages.length > 0 || selectedVideo || selectedDoc) && (
              <div style={styles.previewSection}>
                <div style={styles.imageGrid}>
                  {selectedImages.map((img, index) => (
                    <div key={index} style={styles.thumbContainer}>
                      <img src={img.preview} alt="thumb" style={styles.previewImg} onClick={() => setPreviewIndex(index)} />
                      <button onClick={() => setSelectedImages(selectedImages.filter((_, i) => i !== index))} style={styles.removeImgBtn}><X size={12} /></button>
                    </div>
                  ))}
                  {selectedVideo && (
                    <div style={styles.thumbContainer}>
                      <video src={selectedVideo.preview} style={styles.previewImg} />
                      <button onClick={() => setSelectedVideo(null)} style={styles.removeImgBtn}><X size={12} /></button>
                    </div>
                  )}
                  {selectedDoc && (
                    <div style={styles.thumbContainer}>
                      <FileText size={30} color="#ef4444" />
                      <button onClick={() => setSelectedDoc(null)} style={styles.removeImgBtn}><X size={12} /></button>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Buttons Section */}
            {messageType === 'link' && templateSource === 'message' && (
              <div style={styles.linksContainer}>
                <div style={styles.linkHeader}><LinkIcon size={14} /> <span>Link Buttons</span></div>
                {links.map((link, index) => (
                  <div key={index} style={styles.linkRow}>
                    <div style={styles.linkInputsGroup}>
                        <input placeholder="Label" style={styles.linkInput} value={link.title} onChange={(e) => handleLinkChange(index, 'title', e.target.value)} />
                        <input placeholder="URL" style={styles.linkInput} value={link.url} onChange={(e) => handleLinkChange(index, 'url', e.target.value)} />
                    </div>
                    {index === 0 ? <button onClick={addNewLink} style={styles.addLinkIconBtn}><Plus size={16} /></button> 
                    : <button onClick={() => setLinks(links.filter((_, i) => i !== index))} style={styles.removeLinkBtn}><Trash size={14} /></button>}
                  </div>
                ))}
              </div>
            )}

            <button style={(message.length > 0 && selectedContacts.length > 0) ? styles.btnSendActive : styles.btnSendDisabled} disabled={message.length === 0 || selectedContacts.length === 0 } onClick={sendBroadcastMessage}>
              <Send size={18} /> Send to {selectedContacts.length} Contacts
            </button>
          </div>
          
          {/* IMPORT & SAMPLE SECTION */}
          <div style={styles.uploadCard}>
            <div style={styles.uploadInfo}><FileSpreadsheet size={22} color="#10b981" /><div><div style={{ fontWeight: '700', fontSize: '13px' }}>Import Contacts</div></div></div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button onClick={downloadSampleExcel} style={styles.sampleBtn} title="Download Sample"><Download size={16} /></button>
              <label style={styles.uploadBtn}>Choose Excel<input type="file" style={{ display: 'none' }} onChange={handleFileUpload} /></label>
            </div>
          </div>
        </div>

        <div style={styles.rightPanel}>
          <div style={styles.listCard}>
            <div style={styles.listHeader}>
              <div style={styles.searchBox}><Search size={16} style={styles.searchIcon} /><input style={styles.searchInput} placeholder="Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} /></div>
            </div>
            <div style={styles.listContent}>
              <div style={styles.listSubhead}>
                <div onClick={() => handleSelectAll(!(filteredContacts.length > 0 && filteredContacts.every(c => selectedContacts.includes(c.phone))))} style={styles.col1}>
                  <input type="checkbox" checked={filteredContacts.length > 0 && filteredContacts.every(c => selectedContacts.includes(c.phone))} readOnly />
                  <span>Phone Number</span>
                </div>
                <div style={styles.col2}>Source</div>
              </div>
              {filteredContacts.map((contact) => (
                <div key={contact.phone} style={selectedContacts.includes(contact.phone) ? styles.contactItemActive : styles.contactItem} onClick={() => toggleSelect(contact.phone)}>
                  <div style={styles.col1}>
                    <input type="checkbox" checked={selectedContacts.includes(contact.phone)} readOnly />
                    <div style={styles.userPhone}>{contact.phone}</div>
                  </div>
                  <div style={styles.col2}><span style={{...styles.sourceBadge, ...(contact.source === 'Excel' ? styles.badgeExcel : styles.badgeManual)}}>{contact.source}</span></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {previewIndex !== null && (
        <div style={styles.lightbox} onClick={() => setPreviewIndex(null)}>
          <img src={selectedImages[previewIndex].preview} alt="Full" style={styles.fullImg} />
        </div>
      )}
    </Container>
  );
};

const styles = {
  // Existing styles kept for consistency
  col1: { flex: 2, display: 'flex', alignItems: 'center', gap: '12px' },
  col2: { flex: 1, display: 'flex', justifyContent: 'center' },
  topActionRow: { display: 'flex', gap: '15px', marginBottom: '20px' },
  templateCard: { flex: 1.5, backgroundColor: 'white', padding: '12px 20px', borderRadius: '15px', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center' },
  toggleCardInline: { flex: 1.2, backgroundColor: 'white', padding: '12px 20px', borderRadius: '15px', border: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  dropdown: { padding: '8px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '13px', width: '55%' },
  switchBase: { width: '44px', height: '24px', borderRadius: '12px', position: 'relative', cursor: 'pointer', display: 'flex', alignItems: 'center' },
  switchKnob: { width: '20px', height: '20px', backgroundColor: 'white', borderRadius: '50%', position: 'absolute', transition: 'left 0.2s' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1.6fr', gap: '20px' },
  leftPanel: { display: 'flex', flexDirection: 'column', gap: '20px' },
  card: { backgroundColor: 'white', padding: '20px', borderRadius: '18px', border: '1px solid #e2e8f0' },
  attachmentButtonContainer: { position: 'absolute', bottom: '25px', left: '12px', display: 'flex', alignItems: 'center', gap: '8px' },
  clipBtn: { background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '4px', borderRadius: '6px' },
  emojiBtn: { background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '4px', borderRadius: '6px' },
  attachmentPopup: { position: 'absolute', bottom: '65px', left: '10px', backgroundColor: 'white', borderRadius: '16px', boxShadow: '0 8px 30px rgba(0,0,0,0.12)', padding: '15px 20px', display: 'flex', gap: '25px', zIndex: 100 },
  emojiPickerPopup: {
    position: 'absolute',
    bottom: '65px',
    left: '10px',
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
    border: '1px solid #e2e8f0',
    width: '350px',
    maxWidth: '92vw',
    zIndex: 110,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  emojiPickerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 12px',
    borderBottom: '1px solid #f1f5f9',
    gap: '8px',
    backgroundColor: '#f8fafc'
  },
  emojiSearchWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: '#fff',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    padding: '5px 8px',
    flex: 1
  },
  emojiSearchInput: {
    border: 'none',
    outline: 'none',
    fontSize: '12px',
    width: '100%',
    color: '#1e293b',
    backgroundColor: 'transparent'
  },
  emojiCloseBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#94a3b8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px',
    borderRadius: '4px'
  },
  emojiCategoriesRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '6px 8px',
    borderBottom: '1px solid #f1f5f9',
    backgroundColor: '#ffffff',
    overflowX: 'auto'
  },
  emojiCatBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '3px 6px',
    borderRadius: '6px',
    fontSize: '13px',
    color: '#64748b'
  },
  emojiCatBtnActive: {
    backgroundColor: '#e0e7ff',
    border: 'none',
    cursor: 'pointer',
    padding: '3px 6px',
    borderRadius: '6px',
    fontSize: '13px',
    color: '#4338ca',
    fontWeight: '700'
  },
  emojiGrid: {
    padding: '8px',
    maxHeight: '190px',
    overflowY: 'auto',
    display: 'grid',
    gridTemplateColumns: 'repeat(8, 1fr)',
    gap: '2px'
  },
  emojiCell: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '19px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '6px',
    transition: 'background-color 0.1s, transform 0.1s',
    userSelect: 'none'
  },
  popupItem: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '11px', fontWeight: '600' },
  popupIconCircle: { width: '44px', height: '44px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  previewSection: { marginBottom: '15px', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '10px', backgroundColor: '#f8fafc' },
  imageGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px' },
  thumbContainer: { position: 'relative', height: '80px', borderRadius: '8px', overflow: 'hidden', border: '1px solid #e2e8f0', backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  previewImg: { width: '100%', height: '100%', objectFit: 'cover' },
  removeImgBtn: { position: 'absolute', top: '4px', right: '4px', backgroundColor: 'rgba(239, 68, 68, 0.9)', color: 'white', border: 'none', borderRadius: '50%', width: '18px', height: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10 },
  textArea: { width: '100%', boxSizing: 'border-box', height: '110px', padding: '12px 12px 45px 12px', borderRadius: '12px', border: '1px solid #e2e8f0', backgroundColor: '#f8fafc', marginBottom: '15px', resize: 'none' },
  whatsappBubbleContainer: { width: '100%', boxSizing: 'border-box', minHeight: '110px', padding: '15px', borderRadius: '12px', border: '1px solid #e2e8f0', backgroundColor: '#e5ddd5', backgroundImage: 'url("https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png")', backgroundSize: 'cover', marginBottom: '15px', display: 'flex', flexDirection: 'column' },
  whatsappBubble: { backgroundColor: '#dcf8c6', padding: '10px 14px', borderRadius: '12px', borderTopLeftRadius: '0', maxWidth: '85%', alignSelf: 'flex-start', boxShadow: '0 1px 1px rgba(0,0,0,0.1)', position: 'relative' },
  whatsappText: { fontSize: '14px', color: '#111b21', whiteSpace: 'pre-wrap', wordBreak: 'break-word', lineHeight: '1.4' },
  btnSendActive: { width: '100%', backgroundColor: '#4f46e5', color: 'white', padding: '12px', borderRadius: '10px', fontWeight: '700', cursor: 'pointer', display: 'flex', justifyContent: 'center', gap: '8px', border:'none' },
  btnSendDisabled: { width: '100%', backgroundColor: '#e2e8f0', color: '#94a3b8', padding: '12px', borderRadius: '10px', fontWeight: '700', cursor: 'not-allowed', display: 'flex', justifyContent: 'center', gap: '8px', border:'none' },
  variablesContainer: { padding: '15px', backgroundColor: '#f8fafc', borderRadius: '12px', border: '1px dashed #cbd5e1' },
  variablesHeader: { display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: '700', color: '#475569', marginBottom: '12px' },
  variablesGrid: { display: 'flex', flexDirection: 'column', gap: '10px' },
  variableRow: { display: 'flex', alignItems: 'center', gap: '10px' },
  variableLabel: { fontSize: '13px', fontWeight: 'bold', color: '#1e40af', width: '35px', textAlign: 'center' },
  variableInput: { flex: 1, padding: '10px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '13px', outline: 'none', backgroundColor: 'white' },
  uploadCard: { backgroundColor: 'white', padding: '15px', borderRadius: '15px', border: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  uploadInfo: { display: 'flex', alignItems: 'center', gap: '12px' },
  uploadBtn: { backgroundColor: '#f8fafc', color: '#4f46e5', padding: '8px 14px', borderRadius: '8px', fontSize: '12px', fontWeight: '700', cursor: 'pointer', border: '1px solid #e2e8f0' },
  sampleBtn: { backgroundColor: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0', padding: '8px', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center' },
  listCard: { backgroundColor: 'white', borderRadius: '18px', border: '1px solid #e2e8f0', width: '100%', display: 'flex', flexDirection: 'column' },
  listHeader: { padding: '15px', borderBottom: '1px solid #f1f5f9' },
  searchBox: { position: 'relative' },
  searchIcon: { position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' },
  searchInput: { width: '100%', boxSizing: 'border-box', padding: '10px 10px 10px 35px', borderRadius: '10px', border: '1px solid #f1f5f9', backgroundColor: '#f8fafc', outline: 'none' },
  listContent: { flex: 1, overflowY: 'auto', maxHeight: '500px' },
  listSubhead: { display: 'flex', padding: '12px 20px', fontSize: '11px', fontWeight: '800', color: '#94a3b8', textTransform: 'uppercase', borderBottom: '1px solid #f1f5f9' },
  contactItem: { display: 'flex', padding: '10px 20px', borderBottom: '1px solid #f8fafc', cursor: 'pointer' },
  contactItemActive: { display: 'flex', padding: '10px 20px', backgroundColor: '#f5f7ff', borderBottom: '1px solid #f8fafc', cursor: 'pointer' },
  userPhone: { fontSize: '14px', fontWeight: '500' },
  sourceBadge: { padding: '4px 10px', borderRadius: '20px', fontSize: '10px', fontWeight: '800' },
  badgeExcel: { backgroundColor: '#dcfce7', color: '#047857' },
  badgeManual: { backgroundColor: '#dbeafe', color: '#1d4ed8' },
  statusBadge: { backgroundColor: 'white', padding: '6px 14px', borderRadius: '30px', fontSize: '11px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px', border: '1px solid #e2e8f0' },
  dot: { width: '7px', height: '7px', backgroundColor: '#10b981', borderRadius: '50%' },
  linksContainer: { marginBottom: '20px', padding: '15px', backgroundColor: '#f1f5f9', borderRadius: '12px', border: '1px dashed #cbd5e1' },
  linkHeader: { display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', fontWeight: '700', color: '#475569', marginBottom: '10px' },
  linkRow: { display: 'flex', gap: '10px', marginBottom: '10px', alignItems: 'center' },
  linkInputsGroup: { display: 'flex', flex: 1, gap: '8px' },
  linkInput: { flex: 1, padding: '8px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '13px', outline: 'none', backgroundColor: 'white' },
  removeLinkBtn: { backgroundColor: '#fee2e2', color: '#ef4444', border: 'none', padding: '8px', borderRadius: '8px', cursor: 'pointer' },
  addLinkIconBtn: { backgroundColor: '#e0e7ff', color: '#4f46e5', border: 'none', padding: '8px', borderRadius: '8px', cursor: 'pointer' },
  lightbox: { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  fullImg: { maxHeight: '90%', maxWidth: '90%', objectFit: 'contain' },
};

export default BroadCastManager;